import { Row, Col, Container, Button } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function MegaMenu({ setShowDropdown, categories, handleMouseEnter, handleMouseLeave }) {
	const [activeTab, setActiveTab] = useState(null);
	const [activeCategory, setActiveCategory] = useState(null);

	useEffect(() => {
		if (categories?.length > 0) {
			const firstCategory = categories[0];
			setActiveTab(firstCategory.id);
			setActiveCategory(firstCategory);
		}
	}, [categories]);

	return (
		<Container
			className="mega-menu_container"
			onMouseEnter={handleMouseEnter}
			onMouseLeave={handleMouseLeave}
		>
			<Row className="p-2">
				<Col lg={3} md={3} sm={6} xs={12}>
					<Row className="flex-column">
						{categories?.map((tab, index) => (
							<Button
								size="md"
								variant="light"
								className={`mega-menu_btn d-flex gap-3 ${
									activeTab === tab.id ? "active" : ""
								}`}
								key={index}
								onClick={() => {
									setActiveTab(tab.id);
									setActiveCategory(tab);
								}}
							>
								<img
									src={tab.icon_url}
									alt=""
									style={{
										width: "25px",
										height: "25px",
										objectFit: "contain",
									}}
								/>
								{tab.title}
							</Button>
						))}
					</Row>
				</Col>
				<Col lg={9} md={9} sm={6} xs={12}>
					<Row className="mega-menu_items_grid justify-content-center align-items-start">
						<Row className="p-3">
							{activeCategory?.service_items?.slice(0, 6).map((item, index) => (
								<Col lg={4} md={4} sm={6} xs={12} key={index}>
									<Link
										onClick={() => setShowDropdown(false)}
										to={`/services/${activeCategory.slug}/${item.slug}`}
										className="d-flex flex-column align-items-center text-decoration-none text-dark"
									>
										<Row>
											<img
												src={item.image}
												alt={item.title}
												className="w-100"
											/>
											<p className="text-center fs-6">{item.title}</p>
										</Row>
									</Link>
								</Col>
							))}
						</Row>
						<Row>
							<Col className="d-flex justify-content-end">
								<Link
									to={`/services/${activeCategory?.slug}`}
									className="text-decoration-none mega-menu_see_more fw-bold"
									onClick={() => setShowDropdown(false)}
								>
									See more from {activeCategory?.title} &rarr;
								</Link>
							</Col>
						</Row>
					</Row>
				</Col>
			</Row>
		</Container>
	);
}
